import { detectBrowser } from './helpers/detect-browser';

// Allows for side scrolling by clicking on desktop

const sideScroller = document.querySelector('.side-scroller');
let isDown = false;
let startX;
let scrollLeft;

if (sideScroller) {
    sideScroller.addEventListener('mousedown', (e) => {
        isDown = true;
        sideScroller.classList.add('active');
        startX = e.pageX - sideScroller.offsetLeft;
        scrollLeft = sideScroller.scrollLeft;
    });
    sideScroller.addEventListener('mouseleave', () => {
        isDown = false;
        sideScroller.classList.remove('active');
    });
    sideScroller.addEventListener('mouseup', () => {
        isDown = false;
        sideScroller.classList.remove('active');
    });
    sideScroller.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - sideScroller.offsetLeft;
        const walk = (x - startX) * 3; //scroll-fast
        sideScroller.scrollLeft = scrollLeft - walk;
    });
}

// Controls the switcher hide/show in the home header

const headerSwitcherBtn = document.querySelectorAll('.home-header-switcher');
const headerSwitcherItems = document.querySelectorAll('.home-header-switcher-item');
const headerSwitcherImages = document.querySelectorAll('.home-header-switcher-image');
const headerSwitcherCta = document.querySelectorAll('.home-header-switcher-cta');

if (headerSwitcherBtn) {
    let currentCategory = '';
    let currentBrowser = detectBrowser();

    for (let btn of headerSwitcherBtn) {
        btn.addEventListener('click', event => {
            if (!btn.querySelector('.switcher-state').classList.contains('!bg-hgwa-yellow')) {
                for (let sibling of headerSwitcherBtn) {
                    if (sibling.querySelector('.switcher-state').classList.contains('!bg-hgwa-yellow')) {
                        sibling.querySelector('.switcher-state').classList.toggle('!bg-hgwa-yellow');
                    }
                }
                btn.querySelector('.switcher-state').classList.toggle('!bg-hgwa-yellow');
            }
            currentCategory = btn.dataset.select;
            for (let item of headerSwitcherItems) {
                if (currentBrowser == 'Safari') {
                    item.classList.remove('!h-0');
                    item.classList.remove('!m-0');
                    item.classList.remove('delay-100');
                    item.classList.remove('delay-200');
                    item.classList.remove('delay-300');
                    item.classList.remove('opacity-0');
                }
                if (item.dataset.select == currentCategory) {
                    if (currentBrowser != 'Safari') {
                        item.classList.remove('hidden');
                        const transitions = setTimeout(() => {
                            item.classList.remove('opacity-0');
                            item.classList.remove('!h-0');
                            item.classList.remove('!m-0');
                            clearTimeout(transitions);
                        }, 150);
                    } else {
                        item.classList.remove('hidden');
                    }
                } else {
                    if (currentBrowser != 'Safari') {
                        item.classList.add('!h-0');
                        item.classList.add('!m-0');
                        item.classList.add('sm:hidden');
                        item.classList.add('lg:grid');
                        if (item.classList.contains('delay-100')) {
                            item.classList.remove('delay-100');
                            item.classList.add('delay-1');
                        }
                        else if (item.classList.contains('delay-200')) {
                            item.classList.remove('delay-200');
                            item.classList.add('delay-2');
                        }
                        else if (item.classList.contains('delay-300')) {
                            item.classList.remove('delay-300');
                            item.classList.add('delay-3');
                        }
                        const transitions = setTimeout(() => {
                            item.classList.add('opacity-0');
                            item.classList.add('hidden');
                            item.classList.remove('sm:hidden');
                            item.classList.remove('lg:grid');
                            if (item.classList.contains('delay-1')) {
                                item.classList.remove('delay-1');
                                item.classList.add('delay-100');
                            }
                            else if (item.classList.contains('delay-2')) {
                                item.classList.remove('delay-2');
                                item.classList.add('delay-200');
                            }
                            else if (item.classList.contains('delay-3')) {
                                item.classList.remove('delay-3');
                                item.classList.add('delay-300');
                            }
                            clearTimeout(transitions);
                        }, 150);
                    } else {
                        item.classList.add('hidden');
                    }
                }
            }
            for (let item of headerSwitcherImages) {
                if (item.dataset.select == currentCategory) {
                    item.classList.add('!opacity-100');
                } else {
                    item.classList.remove('!opacity-100');
                }
            }
            for (let item of headerSwitcherCta) {
                if (item.dataset.select != currentCategory) {
                    if (currentBrowser != 'Safari') {
                        item.dataset.select = currentCategory;
                        item.querySelector('.target-text').classList.add('!max-w-0');
                        const textSwap = setTimeout(() => {
                            item.querySelector('.target-text').classList.remove('!max-w-0');
                            if (currentCategory == 'packages') {
                                item.querySelector('.target-text > span').innerHTML = currentCategory;
                                item.href = '/house-land-packages';
                                item.title = 'View all ' + currentCategory;
                            } else if (currentCategory == 'communities') {
                                item.querySelector('.target-text > span').innerHTML = currentCategory;
                                item.href = '/communities';
                                item.title = 'View all ' + currentCategory;
                            } else if (currentCategory == 'land') {
                                item.querySelector('.target-text > span').innerHTML = 'estates';
                                item.href = '/land-for-sale';
                                item.title = 'View all estates';
                            }
                            clearTimeout(textSwap);
                        }, 300);
                    } else {
                        item.dataset.select = currentCategory;
                        item.querySelector('.target-text').classList.add('hidden');
                        item.querySelector('.target-text').classList.remove('!max-w-0');
                        item.querySelector('.target-text').classList.remove('hidden');
                        if (currentCategory == 'packages') {
                            item.querySelector('.target-text > span').innerHTML = currentCategory;
                            item.href = '/house-land-packages';
                            item.title = 'View all ' + currentCategory;
                        } else if (currentCategory == 'communities') {
                            item.querySelector('.target-text > span').innerHTML = currentCategory;
                            item.href = '/communities';
                            item.title = 'View all ' + currentCategory;
                        } else if (currentCategory == 'land') {
                            item.querySelector('.target-text > span').innerHTML = 'estates';
                            item.href = '/land-for-sale';
                            item.title = 'View all estates';
                        }
                    }
                }
            }
        });
    }
}